var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionSmallCloseDefault = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.237 1.263a1.787 1.787 0 0 0-2.527 0L13 9.973l-8.71-8.71A1.787 1.787 0 1 0 1.763 3.79l8.71 8.71-8.71 8.71a1.787 1.787 0 1 0 2.527 2.527l8.71-8.71 8.71 8.71a1.787 1.787 0 1 0 2.527-2.527l-8.71-8.71 8.71-8.71a1.787 1.787 0 0 0 0-2.527z",
    fill: "#1B7690",
    fillRule: "nonzero"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionSmallCloseDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-small-close-default.c0fd2fc3d5d32371711955257d96f96e.svg";